export const getPaymentMethodTextFromTransaction = (transaction) => {
    let paymentMethod = '';
    if (transaction?.stripe_id) {
        paymentMethod = 'stripe';
    } else if (transaction?.vipps_id) {
        paymentMethod = 'vipps';
    } else if (transaction?.invoice_number) {
        paymentMethod = 'faktura';
    }
    return paymentMethod;
};
